import { render, staticRenderFns } from "./CustomerPointsTypeAdd.vue?vue&type=template&id=bf1d02e0&scoped=true&"
import script from "./CustomerPointsTypeAdd.vue?vue&type=script&lang=js&"
export * from "./CustomerPointsTypeAdd.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPointsTypeAdd.vue?vue&type=style&index=0&id=bf1d02e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1d02e0",
  null
  
)

export default component.exports